/**
 * Our initial store state. Used to 'reset' the store.
 */
export default {

    user: {
        favourites: [],
    },
    isLoggedIn: false,
    pendingFavourite: null,

};
